import React, { useState } from "react";
import { Link } from "react-router-dom";

const NavheadDash = () => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleSearchFocus = () => {};

  const menuData = [
    {
      title: 'Home',
      path: '/admin/home',
    },
    {
      title: 'Products',
      sublinks: [
        { title: 'Add Products', path: '/admin/products' },
        { title: 'Cake Product', path: '/admin/cake' },
        { title: 'Special Product', path: '/admin/special' },
        // Add more sublinks as needed
      ],
    },
    {
      title: 'Orders',
      sublinks: [
        { title: 'New Orders', path: '/admin/orders' },
        { title: 'Pending Orders', path: '/admin/pending' },
        { title: 'Complete Orders', path: '/admin/complete' },
        // Add more sublinks as needed
      ],
    },
    {
      title: 'Contact',
      sublinks: [
        { title: 'Get contact', path: '/admin/contact' },
        // Add more sublinks as needed
      ],
    },
  ];

  return (
    <nav className="bg-amber-500 p-4 md:px-8 md:py-4 md:rounded-tl-lg fixed top-0 w-full shadow-lg z-50">
      <div className="container mx-auto flex items-center justify-between">
        <div className="md:hidden">
          <button className="text-white" onClick={toggleMenu}>
            <span className="material-icons">menu</span>
          </button>
        </div>
        <div className="text-white font-bold text-lg md:text-2xl font-nav">
          <Link to="/admin/home" className="text-white py-2">
            Admin Dashboard
          </Link>
        </div>

        <div className="md:flex items-center justify-end mt-4 md:mt-0 space-x-4">
          <div className="relative hidden md:block">
            <input
              type="search"
              placeholder="Search here"
              className="py-2 px-4 w-32 md:w-auto border border-gray-300 rounded-md transition duration-150 ease-in-out text-sm leading-5 focus:outline-none focus:shadow-outline-blue"
            />
          </div>

          <div className="md:hidden">
            <button className="text-amber-600" onClick={handleSearchFocus}>
              <svg
                className="h-5 w-5 text-gray-500"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M21 21l-5.2-5.2"></path>
                <circle cx="10" cy="10" r="8"></circle>
              </svg>
            </button>
          </div>
        </div>
      </div>
      {showMenu && (
  <div className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-50">
    <div className="flex flex-col fixed top-0 left-0 h-full bg-gray-800 w-96 p-4">
      <button className="text-white mb-4" onClick={toggleMenu}>
        Close
      </button>

      {menuData.map((menuItem, index) => (
        <div key={index} className="border-b border-white mb-4">
          <Link
            to={menuItem.path}
            className="text-white py-2 block"
            onClick={() => {
              // Close the menu when a menu item is clicked
              toggleMenu();
            }}
          >
            {menuItem.title}
          </Link>

          {menuItem.sublinks && (
            <ul className="ml-4">
              {menuItem.sublinks.map((sublink, subIndex) => (
                <li className="border-b border-white mb-2" key={subIndex}>
                  <Link
                    to={sublink.path}
                    className="text-white py-2 block"
                    onClick={() => {
                      // Close the menu when a sublink is clicked
                      toggleMenu();
                    }}
                  >
                    {sublink.title}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  </div>
)}


    </nav>
  );
};

export default NavheadDash;
